import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BrandService } from '../../../business-services/brand.service';
import { CompetenceBusinessService } from '../../../business-services/competence.service';
import { AddCompetenceBrandViewModel, AddCompetenceViewModel, BrandValueViewModel } from './../../../business-entities/addCompetence-view-model';


@Component({
  selector: 'app-add-competence',
  templateUrl: './add-competence.component.html'
})
export class AddCompetenceComponent implements OnInit {


  AddCometenceViewModel: AddCompetenceViewModel = {
    Id:0,
    Name: '',
    Code: '',
    Priority: 0,
    IsActive: true,
    ComptenceBrand: []
  }
  brandList: BrandValueViewModel[];
  isSelectAllBrand:boolean;

  constructor(
    private brandService: BrandService,
    private competenceService: CompetenceBusinessService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private toaster: ToastrService,
    private translate: TranslateService,
    private activeModal : NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.getBrandList();
  }

  getBrandList() {
    this.spinner.show();
    this.brandService.getBrand().then(response => {
      if (response) {
        this.brandList = response;
        this.spinner.hide();
      } else if (
        response.responseObject &&
        response.responseObject.errorCount > 0
      ) {
        if (
          response.responseObject.result &&
          response.responseObject.result.errorCode ===
          Enums.ErrorCodes.ServiceCategoriesCode
        ) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  selectAllBrand()
  {
    if(this.isSelectAllBrand)
    {
      for (let item of this.brandList) {
        item.value=true;
      }
    }
    else{
      for (let item of this.brandList) {
        item.value=false;
      }
    }
  }

  AddCompetence() {
    let successMessage = this.translate.instant("lblCompetenceAddedSuccessfully");
    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue");
    for (let item of this.brandList) {
      if (item.value) {
        let CompetenceBrand: AddCompetenceBrandViewModel = {
          BrandId: 0,
          Value: null
        };
        CompetenceBrand.BrandId = item.id;
        CompetenceBrand.Value = item.value.toString();
        this.AddCometenceViewModel.ComptenceBrand.push(CompetenceBrand);
      }
    }
    this.AddCometenceViewModel.Priority=Number(this.AddCometenceViewModel.Priority);
    this.competenceService.addCompetence(this.AddCometenceViewModel).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.activeModal.close({ success: true });
        this.toaster.success(successMessage);
      }
      else if (res.responseCode === Constant.InternalError) {
        let errormsg = this.translate.instant("lblInternalError");
        this.toaster.error(errormsg);
      }
      else if (res.responseCode === Constant.ResponseCode) {
        let errormsg = this.translate.instant("lblAlreadyAddedComptence");
        this.toaster.warning(errormsg);
      }
    }, error => {
      this.spinner.hide();
      if (error.status === Constant.BadRequest) {
        this.toaster.warning(WarningMessage);
      }
      else {
        this.toaster.error(errorMessage);
      }
    });
  }


  public onChangeIsActive(value: boolean) {
    this.AddCometenceViewModel.IsActive = !value;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  OnClose(){
    this.activeModal.close({success:false})
  }
}
